import { render, staticRenderFns } from "./AggregateSettlement.vue?vue&type=template&id=165cbcf1"
import script from "./AggregateSettlement.vue?vue&type=script&lang=js"
export * from "./AggregateSettlement.vue?vue&type=script&lang=js"
import style0 from "./AggregateSettlement.vue?vue&type=style&index=0&id=165cbcf1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports